import React from 'react'
import { Grid } from '@mui/material'
import { InputEntero, InputTexto } from '../../../comp/Input'
import { ModalDetail } from '../../../comp/ModalDetail'
import { Traduccion } from '../../../comp/Traduccion'

export const Detalle = ({ seleccion, accion, isOpen, onSubmit }) => {

    const [formValues, setFormValues] = React.useState({ nombre: null, rotacion: null })
    const [formSubmited, setFormSubmited] = React.useState(false)

    const formChange = (val, id) => setFormValues({ ...formValues, [id]: val })

    React.useEffect(() => {
        if (isOpen) {
            setFormValues(seleccion ?? { nombre: null, rotacion: null })
            setFormSubmited(false)
        }
    }, [seleccion, isOpen])

    const obligatoriosConValor = () => (formValues.nombre ? true : false)

    const _handleSubmit = (res) => {
        if (res && !obligatoriosConValor()) {
            setFormSubmited(true)
            return //si intento enviar form y los obligatorios no están completos interrumpo
        }
        onSubmit(res, { ...formValues, rotacion: !isNaN(formValues.rotacion) && formValues.rotacion > 0 ? +formValues.rotacion : null })
    };

    return <ModalDetail accion={accion} isOpen={isOpen} onSubmit={_handleSubmit}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <InputTexto id='nombre'
                    label={Traduccion('TXT_NOMBRE')}
                    value={formValues.nombre}
                    onChange={formChange}
                    validarSubmit={formSubmited}
                    maxLength={100}
                    requerido/>
            </Grid>
            <Grid item xs={12}>
                <InputEntero id='rotacion'
                    label={Traduccion('TXT_ROTACION')}
                    value={formValues.rotacion}
                    onChange={formChange}
                    validarSubmit={formSubmited}/>
            </Grid>
        </Grid>
    </ModalDetail>
}